/** Shared decorative artwork; file contents and parsed metadata are not inputs. */
export function DatasetDocumentCover() {
  return (
    <img
      src="/dataset-cover.svg"
      alt=""
      className="h-full w-full object-cover"
      data-testid="library-dataset-cover"
      aria-hidden="true"
    />
  )
}
